const bookingValues = ['BOOKING', 'BOOKING_COM', 'BOOKING.COM'];

const normalize = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim().toUpperCase();
};

export const isBookingBlock = (blockedDay) => {
  if (blockedDay?.bookingBlock === true) {
    return true;
  }

  const candidates = [
    blockedDay?.source,
    blockedDay?.type,
    blockedDay?.calendarSource,
    blockedDay?.blockSource,
  ];

  return candidates.some((value) => bookingValues.includes(normalize(value)));
};

export const getBlockedDaySourceLabel = (blockedDay) => {
  if (isBookingBlock(blockedDay)) {
    return 'Booking.com';
  }

  return blockedDay?.sourceLabel || blockedDay?.typeLabel || blockedDay?.source || blockedDay?.type || 'Ręczna';
};
